<div class="row">
  <form [formGroup]="form" class="col-xs-12 forms">
    <div class="info-container">
      <h2>{{ titulo }}</h2>
      <div class="form-group" *ngIf="isShowLojas">
        <span class="icon store"></span>
        <div class="inputs">
          <label for="lojaId">Loja do vendedor</label>
          <select
            formControlName="lojaId"
            id="lojaId"
            required
            appShowErrorMessages
            requiredMessage="Selecionar Loja do Vendedor é obrigatório"
            name="lojaId"
            class="form-control"
          >
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let loja of lojas" [value]="loja.id">
              {{ loja.nome }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <span class="icon user"></span>
        <div class="inputs">
          <label for="vendedorId">Nome do Vendedor</label>
          <app-auto-complete
            formControlName="vendedorId"
            name="vendedorId"
            id="vendedorId"
            [items]="vendedores"
            [key]="vendedorKey"
            [label]="vendedorLabel"
            required="true"
            requiredMessage="Selecionar Vendedor é obrigatório"
            (add)="onAddVendedor($event)"
          ></app-auto-complete>
        </div>
      </div>
    </div>
  </form>
</div>

<app-new-modal-message
  #modalMessage
  title="Atenção!"
  [showFecharBtn]="false"
></app-new-modal-message>
